import {Fragment} from 'react';

import ScrollWatch from './ScrollWatch';
import Headers from './Headers';
import Titles from './Titles';

const Fixed = ({node, panelOpen}) => (
    <ScrollWatch horizontalElement={node}>
        {scrollDirection => (
            <Fragment>
                <Titles scrollDirection={scrollDirection} node={node} panelOpen={panelOpen} />
                <Headers scrollDirection={scrollDirection} node={node} panelOpen={panelOpen} />
            </Fragment>
        )}
    </ScrollWatch>
);

export default Fixed;
